export enum AccessToCoursesEnum {
  None = 0,
  All = 1,
  Specific = 2,
}
